import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { WelcomeListCollection } from "../../search/collections/welcome-list";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { prop} from "../../decorators/property";
import { ReelItemModel, ReelItemType } from "./reel-item";
import { OverviewReelModel } from "./overview-reel";

export class OverviewSearchReelModel extends OverviewReelModel {

    @prop() public Title = "Last search results for: ";
    @prop() public SearchQuery = "Search query";
    @prop() public Type = "search-reel";

    public TempRequestData: ISearchRequestData;
    public TempResponseData: any;

    constructor() {
        super();
        this.setupEvents();
    }

    public loadData() {
        if (this.isPersonalUser()) {
            const requestKey = `my_justis_last_search:${this.user.Email}`;
            const responseKey = `my_justis_last_search_results:${this.user.Email}`;
            const requestData = window.localStorage.getItem(requestKey);
            const responseData = window.localStorage.getItem(responseKey);
            if (responseData) {
                this.parseResults(JSON.parse(requestData), JSON.parse(responseData));
            }
        }
    }

    public triggerSearch() {
        const data = this.TempRequestData;
        const options = {
            page: data.Page,
            query: data.Query,
            order: data.Order,
            materialTypes: data.MaterialFilters,
            includedCategoryFilters: data.CategoryFilters,
            includedProductFilters: data.Indicators
        };

        this.appEvents.trigger(AppEvents.SearchRequest, options);
    }

    private setupEvents() {
        this.listenTo(this.user, "refresh", this.userChanged);
        this.appEvents.on(AppEvents.SearchCompleted, (data) => this.searchCompleted(data));
    }

    private userChanged() {
        this.clearData();
        if (this.isPersonalUser()) {
            this.loadData();
        }
    }

    private clearData() {
        this.TempRequestData = null;
        this.TempResponseData = null;
        this.Items.reset();
        this.SearchQuery = "";
        this.trigger("updateDisplay");
    }

    private searchCompleted(data: ISearchCompletedData) {
        this.SearchQuery = data.request.Query;
        this.TempRequestData = data.request;
        this.TempResponseData = data.response;
        this.parseResults(this.TempRequestData, this.TempResponseData);
        if (this.isPersonalUser()) {
            this.persistData();
        }
    }

    private persistData() {
        this.SearchQuery = this.TempRequestData.Query;
        const requestKey = `my_justis_last_search:${this.user.Email}`;
        const resultsKey = `my_justis_last_search_results:${this.user.Email}`;
        window.localStorage.setItem(requestKey, JSON.stringify(this.TempRequestData));
        window.localStorage.setItem(resultsKey, JSON.stringify(this.TempResponseData));
    }

    private parseResults(requestData: ISearchRequestData, responseData: any) {
        this.Items.reset();
        this.SlideStart = 0;
        this.SearchQuery = requestData.Query;
        this.TempRequestData = requestData;
        responseData.Results.forEach((doc) => {
            const model = this.buildItemModel(doc);
            if (model) {
                this.Items.add(model);
            }
        });
        this.trigger("updateDisplay");
    }

    private buildItemModel(doc) {
        try {
            const model = new ReelItemModel();
            model.Title = doc.Title;
            model.Year = doc.Year !== 0 ? doc.Year : "";
            model.Court = doc.Court;
            model.Url = doc.Url;
            model.Flag = doc.IconClass;
            model.DisplayJurisdiction = doc.DisplayJurisdiction;
            model.Categories = doc.DisplayCategories;
            model.ItemType = ReelItemType.SearchResult;
            return model;
        } catch (err) {
            return null;
        }
    }

}

export interface ISearchCompletedData {
    request: ISearchRequestData;
    response: any;
}

export interface ISearchRequestData {
    Query: string;
    Page: number;
    Order: string;
    ResultsPerPage: number;
    MaterialType: string;
    MaterialFilters: string[];
    Indicators: string[];
    CategoryFilters: string[];
    JurisdictionOverrides: number[];
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/overview-search-reel.ts